
(ns app.strive-forms.question-fields.date-field
  (:require-macros [reagent-mui.util :refer [react-component]])
  (:require [app.strive-forms.component-multi-methods :refer [show-action-btn?
                                                              update-question-input-data update-question-input-local]]
            [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.events :as sfevents]
            [app.strive-forms.helper-functions :refer [component-alignment
                                                       get-default-text-val
                                                       set-values-for-button! update-preview-panel!]]
            [app.strive-forms.styles :refer [date-field-input-wrapper-style
                                             date-field-stack-style]]
            [clojure.string :as s]
            [moment]
            [re-com.core :as re-com :refer [v-box]]
            [re-frame.core :as re-frame]
            [reagent-mui.cljs-time-adapter :refer [cljs-time-adapter]]
            [reagent-mui.material.stack :refer [stack]]
            [reagent-mui.material.text-field :refer [text-field]]
            [reagent-mui.x.localization-provider :refer [localization-provider]]
            [reagent-mui.x.mobile-date-picker :refer [mobile-date-picker]]
            [reagent.core :as r]
            ))



(defmethod update-question-input-local "date" [{:keys [input-data field-id input-value]}]
  (re-frame/dispatch [::sfevents/update-input-local
                      {:input-data input-data :key (keyword field-id) :value input-value}]))

(defmethod update-question-input-data "date" [{:keys [input-data field-id input-value]}]
  (update input-data (keyword field-id) (fn [value]
                                          (assoc value :value input-value))))

(defn- process-response! [{:keys [input-data field-id regenerate-display-fields text-val]}]
  (re-frame/dispatch [::sfevents/update-input-local
                      {:input-data input-data :key (keyword field-id) :value @text-val}])
  (regenerate-display-fields
   (update input-data (keyword field-id) (fn [value]
                                           (assoc value
                                                  :value @text-val)))))

(defmethod show-action-btn? "date" []
  true)

(defn- format-date [date]
  (.format (moment date) "YYYY-MM-DD"))

(defn- handle-start-after-end! [{:keys [end-date start-date]}]
  (when (and (not (s/blank? @end-date)) (> @start-date @end-date))
    (reset! end-date @start-date)))

(defn- handle-end-before-start! [{:keys [end-date start-date]}]
  (when (> @start-date @end-date)
    (reset! start-date @end-date)))

(defn- format-date-to-string [{:keys [date-range? start-date end-date]}]
  (if date-range?
    (str (format-date @start-date) " - " (format-date @end-date))
    (format-date @start-date)))

(defn- change-start-date! [{:keys [end-date date-range? text-val start-date input-data field-id regenerate-display-fields]}]
  (fn [value]
    (reset! start-date (js/Date. value))
    (handle-start-after-end! {:start-date start-date :end-date end-date})
    (reset! text-val (format-date-to-string {:date-range? date-range? :start-date start-date :end-date end-date}))
    (process-response! {:input-data input-data :field-id field-id
                        :regenerate-display-fields regenerate-display-fields :text-val text-val})))

;TODO: check-up moment/alternatives
(defn- change-end-date! [{:keys [end-date date-range? text-val start-date input-data field-id regenerate-display-fields]}]
  (fn [value]
    (reset! end-date (js/Date. value))
    (handle-end-before-start! {:start-date start-date :end-date end-date})
    (reset! text-val (format-date-to-string {:date-range? date-range? :start-date start-date :end-date end-date}))
    (process-response! {:input-data input-data :field-id field-id
                        :regenerate-display-fields regenerate-display-fields :text-val text-val})))

(defn- get-date-field-width [{:keys [screen date-range?]}]
  (let [date-width-without-range (:desktop (:date (:field-inputs-width default-values)))
        date-width-with-range (:desktop (:date-with-range (:field-inputs-width default-values)))
        mobile-date-width-without-range (:mobile (:date (:field-inputs-width default-values)))
        mobile-date-width-with-range (:mobile (:date-with-range (:field-inputs-width default-values)))]
    (cond (and (= screen :desktop) date-range?) date-width-with-range
          (and (= screen :desktop) (not date-range?)) date-width-without-range
          (and (= screen :mobile) date-range?) mobile-date-width-with-range
          (and (= screen :mobile) (not date-range?)) mobile-date-width-without-range)))

(defn- mui-date-picker-field [{:keys [date-range? start-date text-val end-date input-data field-id regenerate-display-fields label value type]}]
  [localization-provider {:date-adapter   cljs-time-adapter}
   [stack {:class (date-field-stack-style {:width (get-date-field-width {:screen :mobile :date-range? date-range?})})}
    [mobile-date-picker {:label label
                         :inputFormat "yyyy-MM-dd"
                         :value value
                         :render-input (react-component [props]
                                                        [text-field props])
                         :on-change    (if (= type :start)
                                         (change-start-date! {:start-date start-date :date-range?
                                                              date-range? :text-val text-val
                                                              :end-date end-date :input-data input-data
                                                              :field-id field-id :regenerate-display-fields regenerate-display-fields})
                                         (change-end-date! {:start-date start-date :date-range?
                                                            date-range? :text-val text-val
                                                            :end-date end-date :input-data input-data
                                                            :field-id field-id :regenerate-display-fields regenerate-display-fields}))}]]])

(defn- date-input-field [{:keys [start-date end-date date-range? text-val input-data field-id regenerate-display-fields align]}]
  [:div
   {:class (date-field-input-wrapper-style {:width (get-date-field-width {:screen :desktop :date-range? date-range?})
                                            :align align})}
   [mui-date-picker-field {:date-range? date-range? :start-date start-date :text-val text-val :end-date end-date
                           :input-data input-data :field-id field-id :regenerate-display-fields regenerate-display-fields
                           :label "Start date" :value @start-date :type :start}]
   (when date-range?
     [mui-date-picker-field {:date-range? date-range? :start-date start-date :text-val text-val :end-date end-date
                             :input-data input-data :field-id field-id :regenerate-display-fields regenerate-display-fields
                             :label "End date" :value @end-date :type :end}])])

(defn date-field [{:keys [field field-id index current-page input-data default-value]}]
  (let [date-range? (:range (:additional_settings field))
        hour (* 60 60 1000)
        day (* 24 hour)
        week (* 7 day)
        start-date (r/atom (js/Date.))
        end-date (r/atom (+ (.now js/Date) (* week)))]
    (fn [{:keys [field input-data field-id regenerate-display-fields input-value is-multi-question?]}]
      (let [text-val (r/atom (get-default-text-val {:input-data input-data :field-id field-id :default-value default-value
                                                    :current-page @current-page :index index :type :date
                                                    :default-date (format-date-to-string {:date-range? date-range? :start-date start-date :end-date end-date})}))]
        (update-preview-panel! {:input-data input-data :field-id field-id
                                :value-to-update @text-val
                                :condition (not (s/blank? @text-val))})
        (add-watch text-val :watcher
                   (fn []
                     (set-values-for-button! {:input-value input-value :component-input-value text-val
                                              :field-id field-id :type (:type field)})))
        [v-box
         :width "100%"
         :align (component-alignment is-multi-question?)
         :justify :center
         :children [(date-input-field {:text-val text-val :start-date start-date :end-date end-date :date-range? date-range?
                                       :input-data input-data :field-id field-id :regenerate-display-fields regenerate-display-fields
                                       :align (component-alignment is-multi-question?)})]]))))
